import { Box, Typography } from "@mui/material"

export const PrivateMessageThread = () => {
    return (
        <Box>
            <Typography variant='h3' sx={{ fontSize: '1.5rem', fontWeight: 400, textAlign: 'center', mt: 3 }}>
                Private Message Thread
            </Typography>
        </Box>
    )
}